import { render } from "./AtoProject.vue?vue&type=template&id=63caf7b6&scoped=true"
import script from "./AtoProject.vue?vue&type=script&lang=js"
export * from "./AtoProject.vue?vue&type=script&lang=js"

import "./AtoProject.vue?vue&type=style&index=0&id=63caf7b6&lang=scss"
import "./AtoProject.vue?vue&type=style&index=1&id=63caf7b6&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63caf7b6"]])

export default __exports__